__turbopack_context__.v({
  "chevron": "Select-module__1AwubG__chevron",
  "item": "Select-module__1AwubG__item",
  "option": "Select-module__1AwubG__option",
  "optionContent": "Select-module__1AwubG__optionContent",
  "optionText": "Select-module__1AwubG__optionText",
  "options": "Select-module__1AwubG__options",
  "optionsWrapper": "Select-module__1AwubG__optionsWrapper",
  "popover": "Select-module__1AwubG__popover",
  "root": "Select-module__1AwubG__root",
  "text": "Select-module__1AwubG__text",
  "trigger": "Select-module__1AwubG__trigger",
});
